const STORAGE_KEY = 'suppressRecurringModal';

/**
 * Checks if the user has opted to suppress the add-to-recurring confirmation modal.
 *
 * @returns {boolean} True if the modal should be suppressed, false otherwise
 */
export const shouldSuppressRecurringModal = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

/**
 * Persists the user's preference to suppress the add-to-recurring confirmation modal.
 *
 * @param {boolean} suppress - Whether to suppress the modal
 */
export const setSuppressRecurringModal = (suppress) => {
    try {
        if (suppress) {
            localStorage.setItem(STORAGE_KEY, 'true');
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch {
        // localStorage may not be available in some contexts
    }
};
